// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
    //suggestionMobileStyle: 'style2'
  }
};

(function () {
  /* This is to inject boost components into this scope, so we can override component's function */
  BoostPFS.inject(this);
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  InstantSearchOnclick.getOnClickData = function() {
    var settings = Settings.getSettingValue('search.searchBoxOnclick');
    // Get from cache
    if (onClickData) {
      onClickData.recent_searches = InstantSearchOnclick.getOnClickRecentSearches();
      return onClickData;
    }
  
    // Get blocks
    var onClickBlocks = [];
    if (Settings.getSettingValue('search.searchBoxOnclick.recentSearch.status')) {
      onClickBlocks.push({
        key: InstantSearchEnum.ResultType.RECENT_SEARCHES,
        values: InstantSearchOnclick.getOnClickRecentSearches()
      });
    }
    if (Settings.getSettingValue('search.searchBoxOnclick.searchTermSuggestion.status')) {
      onClickBlocks.push({
        key: InstantSearchEnum.ResultType.DEFAULT_SUGGESTIONS,
        values: Array.isArray(settings.searchTermSuggestion.data) ? settings.searchTermSuggestion.data : []
      });
    }
    if (Settings.getSettingValue('search.searchBoxOnclick.productSuggestion.status')) {
      // Get products from async call to API
      InstantSearchOnclick.getOnClickProducts(settings.productSuggestion.data);
    }
  
    // Set cache
    onClickData = onClickBlocks;
    return onClickData;
  }
  InstantSearchOnclick.getOnClickProducts = function(productIds) {
    if (!Array.isArray(productIds) || productIds.length == 0) return;
  
    var params = new URLSearchParams();
    params.append('shop', Globals.shopDomain);
    productIds.forEach(id => params.append('ids', id));
    var queryString = params.toString();

    let queyrUrl = Api.getApiUrl('products') + '?' + queryString;
    if (Shopify?.routes?.root !== '/') {
      queyrUrl += '&locale=' + Shopify.routes.root.replace(/\//g, '');
    }
    jQ.ajax({
      method: 'GET',
      url: queyrUrl,
      dataType: 'json',
      success: (data) => {
        onClickData.push({
          key: InstantSearchEnum.ResultType.DEFAULT_PRODUCTS,
          values: data
        })
      }
    })
  }
  var onClickData = null;
})();